import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { logger } from '../common';
export var onSurfaceShown = function onSurfaceShown(surfaceAttributes) {
  try {
    return {
      action: 'shown',
      actionSubjectId: 'aiTopic',
      actionSubject: 'surface',
      eventType: 'track',
      attributes: _objectSpread({}, surfaceAttributes)
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};
export var onRelatedEntityClick = function onRelatedEntityClick(entityClickAttributes) {
  try {
    return {
      action: 'clicked',
      actionSubjectId: 'aiTopic',
      actionSubject: 'relatedEntity',
      eventType: 'ui',
      attributes: _objectSpread({}, entityClickAttributes)
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};
export var onSentimentClick = function onSentimentClick(sentimentClickAttributes) {
  try {
    return {
      action: 'clicked',
      actionSubjectId: 'aiTopic',
      actionSubject: sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
      eventType: 'ui',
      attributes: _objectSpread({}, sentimentClickAttributes)
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};